
var slideCount = null;

//open clicked image
$('.nome-modello-macchina a').click( function() {
   
   var   list = $( '.gallery img', this ).toArray(),
         container = $('.recive-gallery'),
         listLength = list.length,
         slideEl = '',
         i = '';

   function getGallery() {
      for (i = 0; i < listLength; i++) {
         var el =  list[i].outerHTML;
         slideEl += '<div class="slide">' + el + '</div>';
         container.html( slideEl );
      }
   }

   //Slick carousel
   count(),
   getGallery(),
   $('.recive-gallery').slick({
      nextArrow: $('.next'),
      prevArrow: $('.prev'),
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      draggable:true,
   });

   
   $('.modal-gallery').removeClass('modal-gallery-close');
   

});

//close modal & deatroy carousel
$('.close-gallery').click(function() {
   $('.modal-gallery').addClass('modal-gallery-close');
   setTimeout(function(){ 
      $('.recive-gallery').slick('destroy');
   }, 500);
});


//slides counter
function count() {
     $('.recive-gallery').on('init', function(event, slick){
      slideCount = slick.slideCount;
      setSlideCount();
      setCurrentSlideNumber(slick.currentSlide);
    });

    $('.recive-gallery').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      setCurrentSlideNumber(nextSlide);
    });

    function setSlideCount() {
      $('.total').text(slideCount);
    }

    function setCurrentSlideNumber(currentSlide) {
      $('.current').text(currentSlide + 1);
    }  
}



// WEBPACK FOOTER //
// ./scripts/routes/gallery.js